<app-ngx-mat-table
  tableName="Insights Table"
  description="Shows a table of all insights and enables their manipulation."
  dataType="insight"
  sortActive="status"
  [failedInsights]="failedInsights"
  [tableData]="tableData"
  [showActions]="showActions"
  (clickedButton)="clickedButton($event)"
  i18n-tableName
  i18n-description
></app-ngx-mat-table>
<router-outlet></router-outlet>
